import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import { Leveransstatus } from '../../Types/RutinInfoType';

interface IProps {
  leveransstatus: Leveransstatus;
}

const useStyles = makeStyles()(
  (theme: Theme) =>
    ({
      status: {
        display: 'inline-flex',
        fontSize: theme.typography.pxToRem(9),
        fontWeight: 'bold',
        textTransform: 'uppercase',
        lineHeight: 1,
        width: theme.spacing(4),
        minWidth: theme.spacing(3),
        height: theme.spacing(1.5),
        padding: theme.spacing(0.25, 0.25, '1px'),
        borderRadius: theme.spacing(0.5),
        marginLeft: theme.spacing(0.5),
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center',
      },
      alfa: {
        backgroundColor: theme.customProperties.List.statusBackground,
        color: theme.customProperties.List.statusColor,
      },
      beta: {
        // FIXME: Vi kanske borde särskilja Alfa och Beta?
        backgroundColor: theme.customProperties.List.statusBackground,
        color: theme.customProperties.List.statusColor,
      },
      active: {
        display: 'none',
      },
    } as const)
);

/**
 * Ett minichip för att markera Alfa, Beta, eller Active
 */
const DeliveryStatusTag = (props: IProps) => {
  const {
    classes: { status, alfa, beta, active },
    cx,
  } = useStyles();
  return (
    <span
      className={cx(status, {
        [alfa]: props.leveransstatus === 'Alfa',
        [beta]: props.leveransstatus === 'Beta',
        [active]: props.leveransstatus === 'Active',
      })}
    >
      {props.leveransstatus}
    </span>
  );
};

export default DeliveryStatusTag;
